import {NgModule} from '@angular/core'
import {RouterModule} from '@angular/router'
import {CommonModule} from '@angular/common'
import {FormsModule, ReactiveFormsModule} from '@angular/forms'
import {StorageService} from '../core/upload/upload.service'
import {ImageInputComponent} from './image-input/image-input.component'
import {FileInputComponent} from './file-input/file-input.component'
import {FileUploadComponent} from './file-upload/file-upload.component'
import {GalleryComponent} from './gallery/gallery.component'
import {PipeModule} from '../pipe/pipe.module'
import {CheckboxSwitchComponent} from './checkbox-switch/checkbox-switch.component'
import {UserButtonComponent} from './user-button/user-button.component'
import {TableComponent} from './table/table.component'
import {ChatComponent} from './chat/chat.component'
import {FileDragDropComponent} from './file-drag-drop/file-drag-drop.component'
import {TabsComponent} from './tabs/tabs.component'
import {OverlayComponent} from './overlay/overlay.component'
// import { LoaderComponent } from './loader/loader.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    PipeModule,
  ],
  declarations: [
    ImageInputComponent,
    FileInputComponent,
    FileUploadComponent,
    GalleryComponent,
    CheckboxSwitchComponent,
    UserButtonComponent,
    TableComponent,
    ChatComponent,
    FileDragDropComponent,
    TabsComponent,
    OverlayComponent,
    // LoaderComponent,
  ],
  providers: [StorageService],
  exports: [
    ImageInputComponent,
    FileInputComponent,
    FileDragDropComponent,
    FileUploadComponent,
    GalleryComponent,
    CheckboxSwitchComponent,
    UserButtonComponent,
    TableComponent,
    ChatComponent,
    TabsComponent,
    OverlayComponent,
    // LoaderComponent,
  ],
})
export class UISharedModule {}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/ui-shared/ui-shared.module.ts